/**
 * Pagination utilities for server-side pagination.
 *
 * Backend returns pagination metadata via HTTP response headers:
 *   X-Total-Count  – total number of records
 *   X-Total-Pages  – total pages available
 *   X-Page-Number  – current page (0-indexed)
 *   X-Page-Size    – page size
 *
 * When no pagination params are sent the backend returns all data
 * without these headers (backward-compatible mode).
 */

export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [10, 25, 50];

/**
 * Extract pagination metadata from an axios response.
 * Returns null when the response has no pagination headers (unpaged request).
 */
export function extractPaginationHeaders(response) {
  const totalCount = response.headers["x-total-count"];
  if (totalCount == null) return null;

  return {
    totalCount: parseInt(totalCount, 10),
    totalPages: parseInt(response.headers["x-total-pages"], 10),
    pageNumber: parseInt(response.headers["x-page-number"], 10),
    pageSize: parseInt(response.headers["x-page-size"], 10),
  };
}

/**
 * Extract pagination metadata from a fetch Response.
 */
export function extractPaginationHeadersFromFetch(response) {
  const totalCount = response.headers.get("X-Total-Count");
  if (totalCount == null) return null;

  return {
    totalCount: parseInt(totalCount, 10),
    totalPages: parseInt(response.headers.get("X-Total-Pages"), 10),
    pageNumber: parseInt(response.headers.get("X-Page-Number"), 10),
    pageSize: parseInt(response.headers.get("X-Page-Size"), 10),
  };
}

/**
 * Build query string params for a paginated request.
 * page is 1-indexed from the DataTable component but the backend expects 0-indexed.
 */
export function buildPaginationParams(page, perPage) {
  return { page: page - 1, size: perPage };
}
